// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3TNJ-","fileBtn":"File_fileBtn__1upSS","closeBtn":"File_closeBtn__1t1q7","fileSelected":"File_fileSelected__YT25n","disabled":"File_disabled__2v77T"};